import { useState } from "react"
import PropTypes from "prop-types"
import { StatusMessage } from "components/ui"
import { Button, StackView } from "@planningcenter/tapestry-react"
import { api } from "utils/api"

const SignUpName = ({ event: eventFromProps }) => {
  const [status, setStatus] = useState(null)
  const [editing, setEditing] = useState(false)
  const [event, setEvent] = useState(eventFromProps)
  const [name, setName] = useState(event.name)

  const handleChange = e => setName(e.target.value)

  const handleEdit = () => setEditing(true)

  const handleCancel = () => setEditing(false)

  const handleSave = () => {
    setStatus({ text: "Saving...", icon: "spinner" })

    return api
      .put(event.paths.settingsNameDescription, {
        event: {
          name
        }
      })
      .then(response => {
        setEvent(response.event)
        setStatus(null)
        setEditing(false)
      })
      .catch(response => {
        setStatus({
          text: response.errors || "Changes not saved",
          icon: "general#exclamation-triangle",
          type: "error"
        })

        setTimeout(() => setStatus(null), 3000)
      })
  }

  return (
    <>
      {editing ? (
        <StackView axis="horizontal" alignment="center" spacing={1}>
          <div css={{ width: 240 }}>
            <input type="text" value={name} className="lg-input" onChange={handleChange} />
          </div>
          <StackView axis="horizontal" spacing={1}>
            <Button title="Cancel" size="xs" variant="outline" onClick={handleCancel} />
            <Button title="Save" size="xs" theme="create" onClick={handleSave} />
            {status && <StatusMessage {...status} />}
          </StackView>
        </StackView>
      ) : (
        <StackView axis="horizontal" alignment="center" spacing={1} marginBottom="5px">
          <h1 className="mb-0">{event.name}</h1>
          <Button title="Edit" size="xs" variant="outline" onClick={handleEdit} />
        </StackView>
      )}
    </>
  )
}

SignUpName.propTypes = {
  event: PropTypes.shape({
    name: PropTypes.string,
    paths: PropTypes.shape({
      settingsNameDescription: PropTypes.string
    })
  })
}

export default SignUpName
